import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";
import { api } from "services";


import { IS_DEV, SUBAWARDS_SUMMARY_ITEMS } from "globals/constants";
import { subawards as constants } from "store/constants";
import { actionFactory as feedActionFactory } from "store/factories/feed";
import { actionLoaderFactory } from "store/factories/fetchable";
import { dispatch } from "store/store";
import { findSubawards as querySubawards, notifyError, parseJSON } from "utils";
import { countNumberSummaryItems } from "utils/summary";



const factory = actionLoaderFactory(constants, constants.SUBAWARD_LIST);
const summaryFactory = actionLoaderFactory(constants, constants.SUBAWARD_LIST_SUMMARY);

export const { setPaging } = feedActionFactory(constants);

export const findSubawards = ({
	awardId,
	pageLimit,
	pageOffset,
	searchTerms,
	fieldKeys,
	isRefresh = false
}) => {
	return factory.createLoaderAction(
		() => querySubawards({ awardId, pageLimit, pageOffset, searchTerms, fieldKeys }),
		[
			response => {
				factory.setData(response);

				return response;
			},
			(error, { getState }) => {
				const message = IS_DEV ? error.message : getState().dictionary.subawards.errors.subawardListFailedLoad;

				notifyError(message, error);
				factory.setError(message);
			},
		],
		{ isRefresh },
	);
};

export const setSubawardSearchBar = search => {
	dispatch({ type: constants.SET_SEARCH, search: isNonEmptyString(search) ? parseJSON(search) : search });
};

export const getSubawardsSummary = async () => {
	return summaryFactory.createLoaderAction(
		api.subaward.getSummary,
		[
			response => {
				summaryFactory.setData(countNumberSummaryItems(SUBAWARDS_SUMMARY_ITEMS, response));
			},
			error => {
				// const message = IS_DEV ? error.message : getState().dictionary.projects.errors.tilesFailedLoad;
				const message = IS_DEV ? error.message : "An error has occurred";

				notifyError(message, error);
				summaryFactory.setError(message);
			},
		],
	);
};
